import React, { useEffect, useState } from "react";
import "./InstallPWA.css";

const InstallPWA = () => {
  const dismissBtn = () => {
    console.log("dismiss!");
    let div = document.querySelector(".install_container");
    let app = document.querySelector(".app");
    app.removeChild(div);
  };
  const [supportsPWA, setSupportsPWA] = useState(false);
  const [promptInstall, setPromptInstall] = useState(null);

  useEffect(() => {
    const handler = (e) => {
      e.preventDefault();
      console.log("we are being triggered :D");

      checkTimes(e);
    };
    window.addEventListener("beforeinstallprompt", handler);

    const checkTimes = (e) => {
      console.log("checking time...");
      let viewCount = 0;
      if (typeof Storage !== "undefined") {
        let str = sessionStorage.getItem("viewCount");
        if (str) {
          viewCount = JSON.parse(str);
        }
        if (viewCount === 2) {
          setSupportsPWA(true);
          setPromptInstall(e);
          sessionStorage.clear();
        }
        viewCount += 1;
        sessionStorage.setItem("viewCount", viewCount);
      }
    };

    return () => window.removeEventListener("transitionend", handler);
  }, []);

  const onClick = (evt) => {
    evt.preventDefault();
    if (!promptInstall) {
      return;
    }
    promptInstall.prompt();
    let div = document.querySelector(".install_container");
    div.classList.add("scale-out");
    div.classList.remove("scale-in");
  };
  if (!supportsPWA) {
    return null;
  }
  return (
    <div className="install_container scale-transition scale-in">
      <div className="row">
        <div className="">
          <div className="card black darken-1 z-depth-2">
            <div className="card-content white-text">
              <button className="closeBtn right" onClick={dismissBtn}>
                <i className="material-icons">close</i>
              </button>
              <span className="card-title">Track Quicker. Try Ours.</span>
              <p>
                Install our App to get even faster access to Crypto Currency
                prices.
              </p>
            </div>
            <div className="card-action">
              <button
                className="blue waves-effect waves-light btn install_btn"
                id="install_btn"
                aria-label="Install app"
                title="Install app"
                onClick={onClick}
              >
                Install CryptoList App
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InstallPWA;
